import { render, staticRenderFns } from "./MiniIndex.vue?vue&type=template&id=284fee87&"
import script from "./MiniIndex.vue?vue&type=script&lang=js&"
export * from "./MiniIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports